export default "__VITE_ASSET__D$0su58A__"